module.exports = __webpack_public_path__ + "img/title.f1e5f7ea.png";